module.exports = __webpack_public_path__ + "img/提交成功通用背景.3b1b34fb.png";